import User from '../../models/user';

class BaseVoter {
  /**
   * @param User user
   * @returns {boolean}
   */
  isUser (user) {
    return user instanceof User;
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  userHasOneRole (user, roles) {
    const hasRole = user.roles.find(i => roles.includes(i));

    return typeof hasRole !== 'undefined';
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  userHasAllRoles (user, roles) {
    for (const role of roles) {
      if (!user.roles.includes(role)) {
        return false;
      }
    }

    return true;
  }
}

export default BaseVoter;
